import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { DonationButton } from '@toy-projects/ui';

interface LayoutProps {
  children: React.ReactNode;
  showBackButton?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="bg-surface shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-16 py-16 flex items-center justify-between gap-16">
          <div className="flex items-center gap-16">
            {showBackButton && (
              <motion.button
                onClick={() => navigate('/')}
                className="text-textSecondary hover:text-textPrimary transition-colors"
                whileHover={{ x: -4 }}
              >
                ← 홈
              </motion.button>
            )}
            <h1
              className="text-2xl font-bold text-primary cursor-pointer"
              onClick={() => navigate('/')}
            >
              TextKit
            </h1>
          </div>
          <DonationButton amount={3000} label="💝 후원하기" className="text-xs md:text-sm" />
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-16 py-48">{children}</main>

      <footer className="bg-surface mt-96 py-32 border-t border-border">
        <div className="max-w-7xl mx-auto px-16 text-center text-textSecondary text-sm">
          <p>© 2025 TextKit. 간편하고 빠른 텍스트 도구.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
